export enum StatusContasPagarEnum {
  EmAberto = 1,
  Pago = 2,
  Cancelada = 3,
  PagoParcialmente = 4,
  ConciliadoEmAberto = 5
}
